import { UserProfile, WorkoutSettings } from 'fitbeat.gym-core';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { InviterSettingsRow } from './InviterSettingsRow';

interface IProps {
  heading: string;
  description: string;
  userProfile?: UserProfile;
  workoutSettings?: WorkoutSettings;
  actionButton: React.ReactNode;
  t(key: string, options?: any): string;
}

export const InviteSettingsSelection = ({
  heading,
  description,
  workoutSettings,
  actionButton,
  t,
}: IProps) => {
  return (
    <View style={styles.container}>
      <Text style={styles.heading}>{heading}</Text>
      <Text style={styles.description}>
        {description}
      </Text>
      {workoutSettings && (
        <InviterSettingsRow
          workoutSettings={workoutSettings}
          t={t}
          overrideStyles={styles}
        />
      )}
      {actionButton}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginBottom: defaultScale(15),
    borderRadius: defaultScale(3),
    borderWidth: defaultScale(1),
    padding: defaultScale(15),
    borderColor: '#D8D8D8',
  },
  heading: {
    ...Theme.textStyle.heading2,
    textAlign: 'center',
  },
  description: {
    ...Theme.textStyle.bodyCopyReg,
    marginTop: defaultScale(5),
    textAlign: 'center',
    color: Theme.GREY_DARK_MEDIUM,
  },
  iconAndTextContainer: {
    borderRightColor: '#DCDCDC',
  },
});
